import { render } from "./BaseDropdown.vue?vue&type=template&id=68412de7"
import script from "./BaseDropdown.vue?vue&type=script&lang=ts"
export * from "./BaseDropdown.vue?vue&type=script&lang=ts"
script.render = render

export default script